import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "single-range-slider" };
const _hoisted_2 = { class: "slider-container" };
const _hoisted_3 = {
    key: 0,
    class: "background-ranges"
};
const _hoisted_4 = ["title"];
const _hoisted_5 = ["min", "max", "step", "value", "disabled"];
const _hoisted_6 = { class: "handle-value" };
const _hoisted_7 = {
    key: 0,
    class: "min-max-labels"
};
const _hoisted_8 = { class: "min-label" };
const _hoisted_9 = { class: "max-label" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SingleRangeSlider',
    props: {
        value: {},
        min: {},
        max: {},
        step: { default: 1 },
        disabled: { type: Boolean, default: false },
        color: { default: 'blue' },
        formatValue: { type: Function, default: (value) => value.toString() },
        backgroundRanges: { default: () => [] },
        backgroundStyle: { default: 'solid' },
        showMinMax: { type: Boolean, default: false }
    },
    emits: ["update:value"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        // ✅ COMPUTED VALUES
        const valuePercent = computed(() => {
            return ((props.value - props.min) / (props.max - props.min)) * 100;
        });
        const formattedValue = computed(() => {
            return props.formatValue(props.value);
        });
        // ✅ METHODS
        const getBackgroundClass = (color) => {
            // Admin Panel Style: Grün für verfügbare Zeiten, Grau für geschlossen, Orange für Puffer
            if (color === '#22c55e' || color === 'green')
                return 'background-green';
            if (color === '#9ca3af' || color === 'gray')
                return 'background-gray';
            if (color === '#f59e0b' || color === 'orange')
                return 'background-orange';
            return 'background-green'; // Default zu grün (verfügbar)
        };
        // ✅ EVENT HANDLERS
        const handleInput = (event) => {
            const target = event.target;
            const value = Number(target.value);
            emit('update:value', value);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createCommentVNode(" Background Ranges (Admin Panel Style) "),
                    (_ctx.backgroundRanges?.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.backgroundRanges, (range, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    class: _normalizeClass(["background-range", getBackgroundClass(range.color)]),
                                    style: _normalizeStyle({
                                        left: `${((range.start - _ctx.min) / (_ctx.max - _ctx.min)) * 100}%`,
                                        width: `${((range.end - range.start) / (_ctx.max - _ctx.min)) * 100}%`,
                                        zIndex: 10 - index
                                    }),
                                    title: range.label
                                }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_4));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Track "),
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "slider-track" }, null, -1 /* CACHED */)),
                    _createCommentVNode(" Value Handle "),
                    _createElementVNode("input", {
                        type: "range",
                        min: _ctx.min,
                        max: _ctx.max,
                        step: _ctx.step,
                        value: _ctx.value,
                        disabled: _ctx.disabled,
                        onInput: handleInput,
                        class: _normalizeClass(["slider-input", `slider-input-${_ctx.color}`])
                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_5),
                    _createCommentVNode(" Current Value Display "),
                    _createElementVNode("div", {
                        class: _normalizeClass(["slider-handle", `slider-handle-${_ctx.color}`]),
                        style: _normalizeStyle({ left: `${valuePercent.value}%` })
                    }, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(formattedValue.value), 1 /* TEXT */)
                    ], 6 /* CLASS, STYLE */)
                ]),
                _createCommentVNode(" Min/Max Labels "),
                (_ctx.showMinMax)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatValue(_ctx.min)), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formatValue(_ctx.max)), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
